import { Typography, Row, Col, Switch } from "antd";
import { useEffect, useState, useRef } from "react";
import { RiChargingPileLine } from "react-icons/ri";
import LiquidChart from "../../Components/charts/LiquidChart";
import { getStationsData } from "../../redux";

const ChargingStationCard = ({ height, setHeight }) => {
  const heightRef = useRef(null);
  const [stationData, setStationData] = useState([]);

  let [data, setData] = useState([
    {
      id: 1,
      name: "Station 1",
      status: true,
    },
    {
      id: 2,
      name: "Station 2",
      status: false,
    },
    {
      id: 3,
      name: "Station 3",
      status: false,
    },
    {
      id: 4,
      name: "Station 4",
      status: true,
    },
  ]);

  useEffect(() => {
    setHeight(heightRef?.current?.offsetHeight);
  }, [heightRef?.current?.offsetHeight]);

  useEffect(() => {
    (async () => {
      const data = await getStationsData();
      setStationData(data);
    })();
  }, []);

  useEffect(() => {
    const timeoutID = setInterval(async () => {
      const data = await getStationsData();
      setStationData(data);
    }, 10000);

    return () => {
      clearInterval(timeoutID);
    };
  }, []);

  return (
    <div
      className="live-card white-card"
      style={{ height: "100%" }}
      // style={{ height: height ? height : "inherit" }}
      ref={heightRef}
    >
      <Typography.Title
        className="title main-title"
        level={5}
        style={{ fontWeight: "500" }}
      >
        Charging Stations
      </Typography.Title>

      <Row gutter={[0, 20]}>
        {stationData?.map((battery, index) => (
          <Col xs={12} md={6} key={index}>
            <div className="charging-card">
              <LiquidChart
                percentage={battery?.chargedPercent}
                size={100}
                status={battery.status ? "Charging" : "Completed"}
                // color={"#46C782"}
                content
                time={battery.remainingTime}
              />

              <p
                style={{
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 500,
                  color: battery.status ? "#46C782" : "#D5D7E3",
                  fontSize: "0.75rem",
                }}
              >
                {battery.load} kW
              </p>

              <p
                style={{
                  margin: 0,
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 500,
                  color: battery.status ? "#46C782" : "#D5D7E3",
                  fontSize: "0.75rem",
                }}
              >
                <RiChargingPileLine
                  size={15}
                  style={{ marginRight: 5 }}
                  color={battery.status ? "#46C782" : "#D5D7E3"}
                />
                {battery.name}
              </p>
              {/* <Switch
                checkedChildren="ON"
                unCheckedChildren="OFF"
                checked={battery.status}
                onChange={(value) => {
                  let index = data.findIndex((obj) => {
                    return obj.id === battery.id;
                  });
                  data[index].status = value;
                  setData([...data]);
                }}
              /> */}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ChargingStationCard;
